import { FiUser } from "react-icons/fi";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { useNavigate ,NavLink} from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();

  return (
    <div className="fixed top-0 w-full z-50">

      {/* Top Contact Bar */}
      <div className="bg-blue-700 text-white flex justify-end items-center px-6 py-2 text-sm gap-6">

        <div className="flex items-center gap-2">
          <FaPhoneAlt className="text-yellow-300" />
          <span>+91 88864 74446 / 9885931959</span>
        </div>

        <div className="flex items-center gap-2">
          <FaEnvelope className="text-yellow-300" />
          <span>preschool@gmail.com</span>
        </div>

      </div>

      {/* Main Navbar */}
      <nav className="bg-white flex justify-between items-center px-6 py-3">

        {/* Left Side Logo + Menu */}
        <div className="flex items-center gap-2">
           <img
              src="/Avyb_Web_Logo.png"
              alt="Logo"
              className="h-10 w-15"
            />
          <div
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => navigate("/")}
          >
           
            <h2 className="text-xl font-bold text-blue-700 mr-14">
              AVYB Technologies
            </h2>
          </div>

          {/* Menu */}
         <div className="hidden md:flex gap-6 font-medium">

            <NavLink to="/"  className={({ isActive }) =>
                isActive ? "bg-blue-700 text-white px-4 py-2 rounded-lg"
                : "hover:text-blue-600" } >
              Home
            </NavLink>
            <NavLink to="/about"  className={({ isActive }) =>
                isActive ? "bg-blue-700 text-white px-4 py-2 rounded-lg"
                : "hover:text-blue-600" } >
              About Us
            </NavLink>
            
            <NavLink to="/academics"  className={({ isActive }) =>
                isActive ? "bg-blue-700 text-white px-4 py-2 rounded-lg"
                : "hover:text-blue-600" } >
              Academics
            </NavLink>
            <NavLink to="/admission"  className={({ isActive }) =>
                isActive ? "bg-blue-700 text-white px-4 py-2 rounded-lg"
                : "hover:text-blue-600" } >
              Admission Enquiry
            </NavLink>
            <NavLink to="/locations"  className={({ isActive }) =>
                isActive ? "bg-blue-700 text-white px-4 py-2 rounded-lg"
                : "hover:text-blue-600" } >
              Locations
            </NavLink>

            <NavLink to="/contact"  className={({ isActive }) =>
                isActive ? "bg-blue-700 text-white px-4 py-2 rounded-lg"
                : "hover:text-blue-600" } >
              Contact Us
            </NavLink>

          </div>

        </div>

        {/* Right Side Login */}
        <button
          onClick={() => navigate("/login")}
          className="bg-blue-600 flex items-center justify-center w-10 h-10 rounded-full text-white hover:bg-blue-700 transition"
        >
          <FiUser size={20} />
        </button>

      </nav>
    </div>
  );
}

export default Navbar;